import '../../utils/index.mjs';
import _sfc_main from './src/button2.mjs';
import _sfc_main$1 from './src/button-group2.mjs';
export { buttonEmits, buttonNativeTypes, buttonProps, buttonTypes } from './src/button.mjs';
import { withInstall, withNoopInstall } from '../../utils/vue/install.mjs';

const ElButton = withInstall(_sfc_main, {
  ButtonGroup: _sfc_main$1
});
const ElButtonGroup = withNoopInstall(_sfc_main$1);

export { ElButton, ElButtonGroup, ElButton as default };
//# sourceMappingURL=index.mjs.map
